import React from 'react';

const DetailTile = ({ icon, title, value, className, isMobile }) => {
    // Mobile: flat row (icon+title left, value right)
    // Desktop: card style with icon+title on top, value below
    if (!isMobile) {
        return (
            <div className={className || "col-12 col-md-6"}>
                <div className="trace-detail-card">
                    <div className="card-top">
                        <div className="icon-wrap">
                            {icon}
                        </div>
                        <span className="card-title">{title}</span>
                    </div>
                    <div className="card-value">{value}</div>
                </div>
            </div>
        );
    }

    // Mobile: flat row layout
    return (
        <div className={className || "col-12 col-md-6"}>
            <div className="trace-detail-card mobile-row">
                <div className="card-top mobile">
                    <div className="icon-wrap mobile">
                        {icon}
                    </div>
                    <span className="card-title">{title}</span>
                </div>
                <span className="card-value mobile">{value}</span>
            </div>
        </div>
    );
};

export default DetailTile;
